import { render, staticRenderFns } from "./InspectionFeedbackField.vue?vue&type=template&id=875446e6&"
import script from "./InspectionFeedbackField.vue?vue&type=script&lang=js&"
export * from "./InspectionFeedbackField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports